import { isMatch, useMatches } from '@tanstack/react-router';
import { ReactNode } from 'react';

export const useBreadcrumbs = () => {
  const matches = useMatches();
  const matchesWithCrumbs = matches.filter((match) => isMatch(match, 'loaderData.crumb'));

  const breadcrumbs = matchesWithCrumbs.flatMap(({ id, pathname, loaderData }) => {
    const crumbPath = loaderData && 'crumbPath' in loaderData ? loaderData.crumbPath : undefined;

    const extra =
      loaderData && 'breadcrumbItems' in loaderData
        ? (loaderData.breadcrumbItems as {
            label: ReactNode | string;
            path: string;
            search?: Record<string, unknown>;
          }[])
        : undefined;
    return extra
      ? extra.map((item, index) => ({ id: `${id}-${index}`, ...item }))
      : [{ id, label: loaderData?.crumb as ReactNode | string, path: crumbPath ?? pathname }];
  });

  return {
    breadcrumbs,
  };
};
